import * as signalR from "@microsoft/signalr";

export default (app) => {
    return {
        conexaoSignalR: null,
        token: null,
        status: 'conectando',
        onDerrubarUsuario: null, //setado externamente para monitoramento
        onUsuariosConectadosChanged: null, //setado externamente para monitoramento
        // onUsuariosConectadosAllChanged: null, somente para teste
        // onGravaNroUsuariosConectados: null, somente para teste
        onStatusChanged: null, //setado externamente para monitoramento
        changeStatus(status) {
            this.status = status
            console.show(`%%% ConexaoSignalR status ===> ${status}`)
            if (this.onStatusChanged)
                this.onStatusChanged(status)
        },
        start () {
            this.close()
            this.conexaoSignalR = new signalR.HubConnectionBuilder()
                .withUrl(`${getBack(process.env.NODE_ENV)}/hub-UsuarioConectadoHub`, { 
                    accessTokenFactory: async () => {
                        if (app.config.globalProperties.$vistra.Contexto.getToken())                        
                            this.token = app.config.globalProperties.$vistra.Contexto.getToken()
                        return this.token
                    }
                })
                .withAutomaticReconnect()
                .withServerTimeout(90000 + 15000)
                .build();
                
            this.conexaoSignalR.onclose(() => {
                this.changeStatus('desconectado')
            })

            this.conexaoSignalR.onreconnecting(() => {
                console.error("RECONECTANDO HUB USUARIOS")
                this.changeStatus('reconectando')
            })

            this.conexaoSignalR.onreconnected(() => {
                this.changeStatus('conectado')
            })

            let _this = this
            this.conexaoSignalR.on("derrubarUsuario", function() {
                if (_this.onDerrubarUsuario)
                    _this.onDerrubarUsuario(...arguments)
            });
            this.conexaoSignalR.on("usuariosConectados", function() {
                if (_this.onUsuariosConectadosChanged)
                    _this.onUsuariosConectadosChanged(...arguments)
            });

            // para teste de usuários online
            // this.conexaoSignalR.on("usuariosConectadosAll", function() {
            //     if (_this.onUsuariosConectadosAllChanged)
            //         _this.onUsuariosConectadosAllChanged(...arguments)
            // });
            // this.conexaoSignalR.on("gravaNroUsuariosConectados", function() {
            //     if (_this.onGravaNroUsuariosConectados)
            //         _this.onGravaNroUsuariosConectados(...arguments)
            // });

            this.startConexaoSignalR()
        },
        async startConexaoSignalR () {
            try {
                await this.conexaoSignalR.start();
                if (this.conexaoSignalR.state !== signalR.HubConnectionState.Connected)
                    return
                
                this.changeStatus('conectado')
                this.iniciaLeitura()
            } catch (err) {
                if (err.message?.endsWith("'419'"))
                    await app.config.globalProperties.$vistra.refreshToken()
                setTimeout(() => this.startConexaoSignalR(), 5000);
            }
        },
        async close () {
            try {
                if (this.status == 'conectado') {
                    await this.conexaoSignalR.stop(); 
                }
            } catch { }
        },
        derrubarUsuario(idUsuario) {
            if (this.status != 'conectado')
                return
            this.conexaoSignalR
                .invoke("DerrubarUsuario", idUsuario)
                .catch(function (err) {
                    return console.error(err.toString());
                });
        },
        iniciaLeitura() {
            if (this.status != 'conectado')
                return
            this.conexaoSignalR
                .invoke("IniciaLeitura")
                .catch(function (err) {
                    return console.error(err.toString());
                });
        }
    }
}